import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { Provider } from "react-redux";
import { store } from "./shared/store/index.ts";
import { configureAxiosInterceptor } from "@retro-ia/shared/axios";
import { logout } from "@retro-ia/shared/auth";

configureAxiosInterceptor(() => store, logout);

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <App /> 
  </Provider>
);
